import React, { useState } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import Skeleton from '../../Skeleton';

import { Card } from './styles';

const ProgressCard = ({ name, value, icon, percentage, text, isloading }) => {
  return (
    <Card>
      <div className="progress-bar">
        <CircularProgressbar
          value={value}
          text={isloading ? "..." : text}
          styles={buildStyles({
            textSize: '28px',
            trailColor: 'rgb(120, 129, 152)',
            pathColor: `rgb(139, 236, 236)`,
          })}
        />


        {(!text && !isloading) &&
          <img style={{ width: 32, marginTop: -6 }} src={icon} alt="Inteligência" /> 
        }
      </div>
      {isloading ? (
        <div className="card-text">
          <Skeleton isDefault width={120}/>
          <Skeleton isDefault width={100}/>
        </div>
      ) : (
        <div className="card-text">
          <strong>{name}</strong>
          <p>{percentage}</p>
        </div>
      )}

    </Card>
  );
}

export default ProgressCard;